module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/high-growth-culture-1200x630.0e334438.jpg";